// Flat default system fee applied to new "nurse" deployments for
// franchise-Expert locations (see customerChargesSystemFee below).
export const DEFAULT_SYSTEM_FEE = 50.0;

// Whether the customer's location has 'Systemgebühr berechnen' enabled
// (location setting chargesSystemFee, e.g. disabled for the HQ or locations
// run by employees instead of franchise partners). Missing value = enabled,
// same as the column default.
export const customerChargesSystemFee = (customer) =>
    customer?.location?.chargesSystemFee !== false;

// No BK-Einsatz without an agency: a BK-Bedarf only gets one by confirming a
// BK-Vorschlag (docs/plans/care-need-single-agency.md, rule 4 / open question 1).
// Same wording as the backend (NurseDeploymentRepository::applyContractForCreate).
export const NO_CARE_NEED_AGENCY_MESSAGE =
    'Für diesen BK-Bedarf ist noch keine Agentur festgelegt – ohne Agentur gibt es keine Betreuungskraft. Bitte zuerst im Einsatzboard (Menü „Einsatz“) einen BK-Vorschlag bestätigen.';
